/* See https://community.algolia.com/shopify/hogan-helpers.html */

(function(algolia) {
  "use strict";

  var _ = algolia._;

  var formatPrice = function formatPrice(value) {
    return algolia.formatMoney(+value * 100);
  };

  function formattedPriceWithComparison(price, compare_at_price, price_ratio) {
    var comparing = +compare_at_price && +compare_at_price > +price,
      discount_ratio = 1.0 - price_ratio,
      res = "<b>" + formatPrice(price) + "</b>";
    if (comparing) {
      res +=
        ' <span class="ais-hit--price-striked"><span>' +
        formatPrice(compare_at_price) +
        "</span></span> ";
    }

    return res;
  }

  var escapeHtml = function escapeHtml(unsafe) {
    return unsafe
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  };

  algolia.helpers = {
    formatNumber: function formatNumber(text, render) {
      return Number(render(text)).toLocaleString();
    },
    formattedPrice: function formattedPrice(text, render) {
      return formatPrice(render(text));
    },
    formattedPriceWithoutDecimals: function formattedPriceWithoutDecimals(
      text,
      render
    ) {
      return formatPrice(render(text)).replace(/\.\d+$/, "");
    },
    formattedPriceWithComparison: function _formattedPriceWithComparison() {
      return formattedPriceWithComparison(
        this.price,
        this.compare_at_price,
        this.price_ratio
      );
    },
    autocompletePrice: function autocompletePrice(text, render) {
      if (this._distinct) {
        var min = this.variants_min_price;
        var max = this.variants_max_price;
        if (min !== max) {
          return formatPrice(min) + " - " + formatPrice(max);
        }
      }
      return formatPrice(this.price);
      return formattedPriceWithComparison(
        this.price,
        this.compare_at_price,
        this.price_ratio
      );
    },
    instantsearchPrice: function instantsearchPrice(text, render) {
      if (
        this.product_type === "Retail Only" ||
        (this.named_tags.attribute &&
          this.named_tags.attribute.includes(":available-sale::instore-only"))
      ) {
        return "Call for price";
      }

      if (this._distinct) {
        var min = this.variants_min_price;
        var max = this.variants_max_price;
        if (min !== max) {
          return "<b>" + formatPrice(min) + " - " + formatPrice(max) + "</b>";
        }
      }

      if (this.price <= 0) {
        return "Call for price";
      }

      return formattedPriceWithComparison(
        this.price,
        this.compare_at_price,
        this.price_ratio
      );
    },
    fullTitle: function fullTitle() {
      var res = this.title;
      if (
        !this._distinct &&
        this.variant_title &&
        this.variant_title !== "Default Title" &&
        this.variant_title !== "Default"
      ) {
        res += " (" + this.variant_title + ")";
      }

      return escapeHtml(res);
    },
    fullHTMLTitle: function fullHTMLTitle() {
      var res = this._highlightResult.title.value;
      if (
        !this._distinct &&
        this.variant_title &&
        this.variant_title !== "Default Title" &&
        this.variant_title !== "Default"
      ) {
        res +=
          ' <span class="algolia-variant">(' +
          this._highlightResult.variant_title.value +
          ")</span>";
      }

      return res;
    },
    floor: function floor(text, render) {
      return "" + Math.floor(+render(text));
    },
    ceil: function ceil(text, render) {
      return "" + Math.ceil(+render(text));
    },
    sizedImage: function sizedImage(text, render) {
      var image = this._distinct ? this.product_image : this.image;
      if (!image) {
        return "https://cdn.shopify.com/s/files/1/1750/0827/t/50/assets/coming_soon_image_100x.jpg?10729";
      }
      var size = render(text).replace(/^\s+|\s+$/g, ""); // Render and trim
      if (size === "original") {
        return image;
      }
      return image.replace(/\/(.*)\.(\w{2,4})/g, "/$1_" + size + ".$2");
    },
    productBanner: function productBanner() {
      var backorderable = this.inventory_policy == "continue";
      var inventoryQuantity = this.inventory_quantity;
      var dropshipment = (this.named_tags.attribute && 
                           this.named_tags.attribute.includes(":SHIPPING_GROUPS::free-dropshipment"));
      
      if (dropshipment && this.compare_at_price !== null &&
        this.compare_at_price > this.price)
      {
        return '<div class="product-banner is--sale">Sale</div>';
      }
        
      else if  (backorderable && inventoryQuantity <= 0) {
        return '<div class="product-banner is--back-order">Back order</div>';
      } 
      
      else if (
        this.compare_at_price !== null &&
        this.compare_at_price > this.price
      ) {
        return '<div class="product-banner is--sale">Sale</div>';
      }

      return "";
    },
    productStockIndicatorBtnClass: function productStockIndicatorBtnClass() {
      return this.inventory_quantity > 0 ? "btn-in-stock" : "btn-out-of-stock";
    },
    productStockIndicatorAvailabilityClass: function productStockIndicatorAvailabilityClass() {
      return this.inventory_quantity > 0 ? "in-stock" : "out-of-stock";
    },
/*    productStockIndicatorLabel: function productStockIndicatorLabel() {
      return this.inventory_quantity > 0 ? "In Stock" : "Out of Stock";
    },*/

     productStockIndicatorLabel: function productStockIndicatorLabel() {
     /*var tracking = this.inventory_management == "shopify";*/
     var inventoryQuantity = this.inventory_quantity;
     var dropshipment = (this.named_tags.attribute && 
                           this.named_tags.attribute.includes(":SHIPPING_GROUPS::free-dropshipment"));
       
      if (inventoryQuantity > 0)
      {
        return 'In Stock';
      } 
      else if (inventoryQuantity <= 0 && dropshipment)
      {
        return 'Drop Shipping';
      }
       else if (inventoryQuantity <= 0)        
      {
        return 'Out of Stock';
      } 
      return "";
    },
    
    
   
    productWithFreeShipping: function productWithFreeShipping() {
      var isFreeShipping = (this.named_tags.attribute && this.named_tags.attribute.includes(":SHIPPING_GROUPS::free-shipping")  || this.named_tags.attribute &&
          this.named_tags.attribute.includes(":SHIPPING_GROUPS::free-shipping-pallet") || this.named_tags.attribute &&
          this.named_tags.attribute.includes(":SHIPPING_GROUPS::free-dropshipment"))  || (this.tags &&
	      	  this.tags.includes("Stack Kits"));
      return isFreeShipping ? '<div class="is--free-shipping">with Free Shipping</div>' : "";
    },
    productIsUsaStar: function productIsUsaStar() {
      var oem_brands = "attribute::brand::freightliner,attribute::brand::detroit-diesel,attribute::brand::western-star,attribute::brand::kenworth,attribute::brand::peterbilt,attribute::brand::mack,attribute::brand::caterpillar,attribute::brand::cummins,attribute::brand::thomas-built,attribute::brand::international,attribute::brand::volvo,attribute::brand::eaton-fuller,attribute::brand::meritor,attribute::brand::hino,attribute::brand::sterling,attribute::brand::timken".split(",")
      var isUsaStar = (this.named_tags.attribute && this.named_tags.attribute.includes(":brand::usa-star"));
      var imgUsaStar = isUsaStar ? "<img src='//miamistar.com/cdn/shop/t/63/assets/brand_usa-star.svg?v=7849136923116309531791821090' alt='USA STAR' onError='style.display=\'none\';'>" : ""; 
      var isOEM = false;
      if (this.named_tags.attribute) {
        Object.values(this.named_tags.attribute).map(attr => {
          if (attr.includes(":brand::") && !isUsaStar) {
            oem_brands.map(oem => {
              if (oem.includes(attr)){
                isOEM = true
                return;
              }
            })
          }
        });
      }
      
      var imgOEMorAF = isOEM ? "//miamistar.com/cdn/shop/t/63/assets/brand_oem.svg?v=36501598659026403851791821090" : "//miamistar.com/cdn/shop/t/63/assets/brand_af.svg?v=82961926211924074071791821090";
      // return isUsaStar ? '<div class="product--is--usa--star">' + imgUsaStar +  '</div>' : '';
      return '<div class="product--is--usa--star"><img src="' + imgOEMorAF + '" alt=" "  onError="style.display=\'none\';">' + imgUsaStar + '</div>'
      // );
    },

    

    productIsRoadworks: function productIsRoadworks() {
      var oem_brands = "attribute::brand::freightliner,attribute::brand::detroit-diesel,attribute::brand::western-star,attribute::brand::kenworth,attribute::brand::peterbilt,attribute::brand::mack,attribute::brand::caterpillar,attribute::brand::cummins,attribute::brand::thomas-built,attribute::brand::international,attribute::brand::volvo,attribute::brand::eaton-fuller,attribute::brand::meritor,attribute::brand::hino,attribute::brand::sterling,attribute::brand::timken".split(",")
      var isRoadworks = (this.named_tags.attribute && this.named_tags.attribute.includes(":brand::roadworks"));
      var imgRoadworks = isRoadworks ? "<img style='width:100px' src='//miamistar.com/cdn/shop/t/63/assets/brand_roadworks.svg?v=146092846110306922381791821090' alt='Roadworks' onError='style.display=\'none\';'>" : ""; 
      var isOEM = false;
      if (this.named_tags.attribute) {
        Object.values(this.named_tags.attribute).map(attr => {
          if (attr.includes(":brand::") && !isRoadworks) {
            oem_brands.map(oem => {
              if (oem.includes(attr)){
                isOEM = true
                return;
              }
            })
          }
        });
      }
      
      var imgOEMorAF = isOEM ? "//miamistar.com/cdn/shop/t/63/assets/brand_oem.svg?v=36501598659026403851791821090" : "//miamistar.com/cdn/shop/t/63/assets/brand_af.svg?v=82961926211924074071791821090";
      // return isRoadworks ? '<div class="product--is--usa--star">' + imgRoadworks +  '</div>' : '';
      return '<div class="product--is--usa--star"><img src="' + imgOEMorAF + '" alt=" "  onError="style.display=\'none\';">' + imgRoadworks + '</div>'
      // );
    }
  };

  _.forEach(
    [
      "pico",
      "icon",
      "thumb",
      "small",
      "compact",
      "medium",
      "large",
      "grande",
      "original"
    ],
    function(size) {
      algolia.helpers[size + "Image"] = (function(_size) {
        return function() {
          var image = this._distinct ? this.product_image : this.image;
          if (!image) {
            return "https://cdn.shopify.com/s/files/1/1750/0827/t/50/assets/coming_soon_image_100x.jpg?10729";
          }
          if (_size === "original") {
            return image;
          }
          return image.replace(/\/(.*)\.(\w{2,4})/g, "/$1_" + _size + ".$2");
        };
      })(size); // We need to create a new scope so that the internal size has the good value.
    }
  );

  /* Create an Hogan lambda, which doesn't respect the mustache doc */
  algolia.hoganHelpers = _.reduce(
    algolia.helpers,
    function(res, helper, name) {
      res[name] = function() {
        return function(text) {
          var render = function(value) {
            return Hogan.compile(value, algolia.hoganOptions).render(this);
          }.bind(this);
          return helper.call(this, text, render);
        }.bind(this);
      };
      return res;
    },
    {}
  );
})(algoliaShopify);
